import { useMediaQuery } from "@reactuses/core";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "../../../redux/hooks";
import { useLocation } from "@tanstack/react-router";
import { HoverInfo } from "../basic/Tooltip";

interface Props {
  /** Metric id (e.g. "sales") used to gate display of this warning. */
  metricId?: string;
}

const TotalSalesVendorWarning = ({ metricId }: Props) => {
  const { t } = useTranslation(["common"]);
  const toolTipIconMinWidth = useMediaQuery("(min-width:1000px)");
  const toolTipIconMaxWidth = useMediaQuery("(max-width:1500px)");
  const channel = useAppSelector((state) => state.channel.currentChannel);
  const orgType = useAppSelector((state) => state.user.organization_type);
  const pathname = useLocation({ select: (location) => location.pathname });

  if (channel !== "amazon" || orgType !== "vendor" || metricId !== "sales" || pathname.includes("dsp")) {
    return null;
  }

  const message = t(($) => $.common.totalSalesVendor["Total sales stats may be delayed by 3-7 days for vendors"]);

  return toolTipIconMaxWidth && toolTipIconMinWidth ?
      <span style={{ position: "absolute", left: "20px", color: "yellow" }}>
        <HoverInfo iconCss={{ display: "inline", paddingStart: "small", color: "grey" }}>{message}</HoverInfo>
      </span>
    : <div
        style={{
          position: "absolute",
          left: "15px",
          width: "35%",
          fontSize: "10px",
          textAlign: "initial",
        }}
      >
        <p
          style={{
            fontSize: "10px",
            textTransform: "none",
          }}
        >
          <i className="fa fa-warning fa-sm text-muted" />
          {message}
        </p>
      </div>;
};

export default TotalSalesVendorWarning;
